import { addDays, isValid } from "date-fns";

const isMidnight = (date) => date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0;

export const getEffectiveDue = (dueCentral) => {
    if (!(dueCentral instanceof Date) || !isValid(dueCentral) || !isMidnight(dueCentral)) {
        return dueCentral;
    }

    return addDays(dueCentral, 1);
};
